import { useState } from 'react';
import { Icon } from '@mui/material';
import { TAB_MENU } from 'types/room';
import { CollapseView } from 'components/sessions/CollapseView';
import TopTabs from 'components/TopTabs';
import TopTabItem from 'components/TopTabs/TopTabItem';
import { IAccordeon } from 'contexts/menuChats/types';
import NoConversations from 'components/NoConversations';
import { SESSION_TYPE } from 'types/chat';
import { flag, useFeatureFlag } from 'hooks/useFeatureFlag';

export interface ChatTabsMenuProps {
  chats: IAccordeon[];
  type: TAB_MENU;
  isLoading?: boolean;
}

const ChatTabsMenu = ({ chats, type, isLoading }: ChatTabsMenuProps) => {
  const [value, setValue] = useState(0);
  const isStartedByYouEnabled = useFeatureFlag(flag.STARTED_BY_YOU);

  const isDisableTab = (chat: IAccordeon) => {
    if (chat.id === SESSION_TYPE.STARTED_BY_YOU && isStartedByYouEnabled) {
      return !chat.templates?.length;
    }
    return !chat.rooms.length;
  };

  const getCount = (chat: IAccordeon) => {
    if (chat.id === SESSION_TYPE.STARTED_BY_YOU && isStartedByYouEnabled) {
      return chat.templates?.length;
    }
    return chat.rooms.length;
  };

  return (
    <>
      <TopTabs value={value} onChange={(_, newValue) => setValue(newValue)}>
        {chats.map((chat, index) => {
          if (chat.id === SESSION_TYPE.STARTED_BY_YOU && !isStartedByYouEnabled) {
            return null;
          }
          return (
            <TopTabItem
              key={chat.id}
              label={chat.title}
              value={index}
              count={getCount(chat)}
              disabled={isDisableTab(chat)}
              icon={<Icon className={`fa-regular fa-${chat.icon}`} />}
            />
          );
        })}
      </TopTabs>
      {chats.map((chat, index) => (
        <>
          {getCount(chat) === 0 && value === index && !isLoading && (
            <NoConversations key={`no-conversations-${chat.id}`} />
          )}
          <CollapseView key={chat.id} item={chat} type={type} expanded={value === index} timeout={0} />
        </>
      ))}
    </>
  );
};

export default ChatTabsMenu;
